module.exports = __webpack_public_path__ + "img/color_rojo.bed92ab4.svg";